import React from 'react';
import {BrowserRouter as Router, Link, Switch, Route} from 'react-router-dom';
import './About.scss';
import {StandardSection, PhotoHeaderSection, Footer} from './Layouts';
import profile from './media/profile.jpg';

function Position(props) {
    return (
        <div className="position-wrapper">
            <div className="position-title">
                <h3>{props.company}</h3>
                <p>{props.title}</p>
                <p>{props.date}</p>
            </div>
            <div className="position-description">
                <ul>
                    {props.description.map(d => <li>{d}</li>)}
                </ul>
            </div>
        </div>
    );
}

const jobs = [
    {
        title: "Assurance Intern",
        company: "PwC",
        date: "September-November 2021",
        description: ["Description here"]
    }
];

class About extends React.Component {
    render() {
        return (
            <div className="about-page page">
                <PhotoHeaderSection img={profile} color={"retro-brown2"}>
                    <div className="photo-header-section-text">
                        <h2>developer, data storyteller, photographer.</h2>
                        <p>Hi there! I'm Chee, and currently, I'm a second-year at UniMelb studying:</p>
                        <ul>
                            <li>Computer Science</li>
                            <li>Data Science</li>
                        </ul>
                        <p>Although I have many varied interests, what I am passionate about is ...</p>
                        <p>When I'm not doing that, I'm usually shooting film with my 35mm camera or baking.</p>
                        <p>Interested in learning more? Please feel free to contact me at <a href="mailto:cyxiangg@gmail.com">cyxiangg@gmail.com</a>. Looking forward to hearing from you!</p>
                    </div>
                </PhotoHeaderSection>
                <StandardSection color="white" styles={{"padding-top": "4rem"}}>
                    <div className="section">
                        <h2>Experience</h2>
                        {jobs.map(position => (
                            <Position title={position.title} company={position.company} date={position.date} description={position.description} />
                        ))}
                        <p><Link to="/resume" className="button">Resume</Link></p>
                    </div>
                </StandardSection>
                <Footer />
            </div>
        );
    }
}

export default About;
